import { useTheme } from "@mui/material/styles";
import Button from "@components/Button/Button";
import { useTranslation } from "react-i18next";

interface ErrorMessageProps {
  errorMessageTitle: string;
  errorMessageDescription: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
  testId?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessageTitle,
  errorMessageDescription,
  cancelButtonLabel,
  confirmButtonLabel,
  onCancel,
  onConfirm,
  testId = "vessel-scan-error",
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className="mt-12 p-5" data-testid={testId}>
      <div className="max-w-[820px] mx-auto">
        <div
          className="pt-14 px-16 pb-16"
          style={{
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: "#F7F8FA",
          }}
        >
          <div className="max-w-[760px] mx-auto text-center">
            <h2
              className="m-0 text-2xl font-semibold"
              style={{ color: theme.palette.text.primary }}
              data-testid={`${testId}-title`}
            >
              {errorMessageTitle}
            </h2>
            <p
              className="mt-3 text-sm leading-5"
              style={{ color: theme.palette.text.secondary }}
              data-testid={`${testId}-description`}
            >
              {errorMessageDescription}
            </p>
          </div>
        </div>
        <div className="flex justify-end gap-4 mt-4">
          <Button
            variant="text"
            color="secondary"
            label={cancelButtonLabel ?? t("common.cancel")}
            onClick={onCancel}
            sx={{ textTransform: "none" }}
            testId={`${testId}-cancel-button`}
          />
          <Button
            variant="contained"
            label={confirmButtonLabel ?? t("common.confirm")}
            onClick={onConfirm}
            sx={{ textTransform: "none", minWidth: 160 }}
            testId={`${testId}-confirm-button`}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
